import { render, staticRenderFns } from "./tdsIntro.vue?vue&type=template&id=1664671a&scoped=true"
import script from "./tdsIntro.vue?vue&type=script&lang=js"
export * from "./tdsIntro.vue?vue&type=script&lang=js"
import style0 from "./tdsIntro.vue?vue&type=style&index=0&id=1664671a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1664671a",
  null
  
)

export default component.exports